import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetExchangeContractRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetExchangeContractResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getExchangeContract = (request: GetExchangeContractRequest, options?: CashRequestOptions) =>
  post<GetExchangeContractRequest, GetExchangeContractResponse>('/2.0/cash/get-exchange-contract', request, {
    ...options,
    rejectOnError: true,
  })
